import type { KeyboardEvent } from "react";
import { inputClass } from "../../components/ui";

/** The standard panel input; prefer the Input/Textarea/Select components. */
export const editInputClass = inputClass();

export const onEscapeCancel =
  (onCancel?: () => void) => (event: KeyboardEvent) => {
    if (event.key === "Escape") onCancel?.();
  };
